import { useEffect } from "react";
import ClearOrFill from "./Text/ClearOrFill";
import DateTime from "./Text/DateTime";
import Lorem from "./Text/Lorem";
import Split from "./Text/Split";
import ComingSoonDivider from "../PowerPack_Common/ComingSoonDivider";
import Merge from "./Text/Merge";
import TableOfContents from "./Text/TableOfContents";

export default function TextTools({ boardSelection, userIsPro, environment }) {
  useEffect(() => { }, [environment]);
  return (
    <div className="scrollable mt-0">
      <Lorem />
      <DateTime />
      <ClearOrFill />
      <Split boardSelection={boardSelection} />
      <TableOfContents
        boardSelection={boardSelection}
        userIsPro={userIsPro}
        environment={environment}
      />


      <ComingSoonDivider visible={true} /> {/* ---------------------------------------------------- */}

      <Merge
        boardSelection={boardSelection}
        userIsPro={userIsPro}
        environment={environment}
      />
      <div className="grid tool-section mt-16 pos-rel">
        <div className="centered-overlay crosshatch"></div>
        <div className="cs1 ce12">
          <div className="h3 mb-8">Create Item-Link Table of Contents</div>
          <div className="cs1 ce12 p-medium mt-0">
            From many items, generate a way-finding table of contents with
            internal board links back to those items.
          </div>
        </div>
      </div>
      {/* <div className="grid tool-section mt-16 pos-rel">
        <div className="centered-overlay crosshatch"></div>
        <div className="cs1 ce12">
          <div className="h3 mb-8">Merge</div>
          <div className="cs1 ce12 p-medium mt-0">
            Merge many items' text into one item.
          </div>
        </div>
      </div> */}
    </div>
  );
}
